import axios from 'axios'

const instance = axios.create({
  timeout: 8000,
  withCredentials: true
})
export default instance



// WEBPACK FOOTER //
// ./src/api/index.js